import { Box, Dialog, DialogContent, DialogTitle, Divider, Typography } from '@mui/material';

const SHORTCUTS: { keys: string[]; label: string }[] = [
  { keys: ['Ctrl', 'K'], label: 'Open the command palette' },
  { keys: ['/'], label: 'Open the command palette (search)' },
  { keys: ['?'], label: 'Show this shortcuts help' },
  { keys: ['Esc'], label: 'Close a dialog, menu or panel' },
  { keys: ['↑', '↓'], label: 'Move selection in lists and the palette' },
  { keys: ['Enter'], label: 'Open the selected item or row' },
  { keys: ['Space'], label: 'Activate the focused row' },
  { keys: ['Ctrl', 'C'], label: 'Copy the focused table row' },
  { keys: ['Tab'], label: 'Move focus to the next control' },
];

function Key({ label }: { label: string }) {
  return (
    <Box
      component="kbd"
      sx={{
        fontFamily: 'var(--mono)',
        fontSize: '0.72rem',
        px: 0.75,
        py: 0.25,
        minWidth: 22,
        textAlign: 'center',
        border: '1px solid',
        borderColor: 'divider',
        borderBottomWidth: 2,
        borderRadius: 1,
        bgcolor: 'surface.raised',
      }}
    >
      {label}
    </Box>
  );
}

export function ShortcutHelp({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth aria-label="Keyboard shortcuts">
      <DialogTitle>Keyboard shortcuts</DialogTitle>
      <Divider />
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
          {SHORTCUTS.map((s) => (
            <Box key={s.label} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Box sx={{ display: 'flex', gap: 0.5, minWidth: 96 }}>
                {s.keys.map((k, i) => (
                  <Key key={i} label={k} />
                ))}
              </Box>
              <Typography variant="body2" color="text.secondary">
                {s.label}
              </Typography>
            </Box>
          ))}
        </Box>
      </DialogContent>
    </Dialog>
  );
}
